// extracted by mini-css-extract-plugin
export default {"dropdownDiv":"CustomDropdown_dropdownDiv__0EGXZ","multipleDropdownsDiv":"CustomDropdown_multipleDropdownsDiv__Fx3gw","dropdown":"CustomDropdown_dropdown__Rs0wU"};